<div class="form-group form-horizontal row">
    <label class="col-xs-9 control-label">
        {{ "add_to_block_gallery" | translate }}
    </label>
    <div class="col-xs-3 text-right">
        <sp-switch [active]="enabled.value" (toggleActiveEvent)="setEnabled($event)"></sp-switch>
    </div>
</div>

@if (enabled.value) {
    <div class="well mt-15 row">
        <div class="form-group">
            <div class="col-xs-6">
                <input
                    type="text"
                    class="form-control"
                    placeHolder="Name"
                    [formControl]="name"
                    [maxlength]="nameMaxLength"
                />
            </div>
            <div class="col-xs-6">
                <select
                    class="form-control"
                    (change)="setCategory($event)"
                    required
                    style="font-size: small"
                    [formControl]="category"
                >
                    @for (category of categories | keyvalue; track category) {
                        <option [value]="category.key">
                            {{ category.value }}
                        </option>
                    }
                </select>
            </div>
        </div>
    </div>
}
